import { Typography } from '@material-ui/core';

const NotFound = () => {
  return <Typography>not found page</Typography>;
};

export default NotFound;
